export default __webpack_public_path__ + "static/media/logo.f4b1e5bb.png";